import { i18n } from "@lingui/core";

export const locales = {
  en: "English",
  vi: "Vietnamese",
} as const;

export type LocaleString = keyof typeof locales;

export const defaultLocale: LocaleString =
  (localStorage.getItem("lo") as LocaleString) || "en";

/**
 * We do a dynamic import of just the catalog that we need
 * @param locale any locale string
 */

export const nextLang = async () => {
  const currentLang = localStorage.getItem("lo");
  const langs = Object.keys(locales);
  const idx = langs.findIndex((el) => el === currentLang);
  await dynamicActivate(langs[(idx + 1) % langs.length] as LocaleString);
};

export const switchLang = async (lang: LocaleString) => {
  await dynamicActivate(lang);
};

export const dynamicActivate = async (locale: LocaleString) => {
  localStorage.setItem("lo", locale);
  const { messages } = await import(`./locales/${locale}/messages.po`);
  console.log("messages", messages);
  i18n.load(locale, messages);
  i18n.activate(locale);
};
